module.exports = __webpack_public_path__ + "static/80126751_532902447567114_3294889589965062144_n_optimized-d65c0a0a7c97fc1588b75c3fbb9052f1.jpg";